import { combineEpics } from 'redux-observable';

import checkCodeStatusEpic from './checkCodeStatus.epic';
import resetPasswordEpic from './resetPassword.epic';

export default combineEpics(checkCodeStatusEpic, resetPasswordEpic);
